import { useEffect, useState, useRef, useCallback, useLayoutEffect } from "react";
import { Row, Col, message, Carousel } from "antd";
import { GetCourseContent, getCoursePeriods } from "../ajax";
import { NavLink, useParams } from "react-router-dom";
import { CoursePagePerspectiveDLC } from "./courseDlc";
import { useModal } from "../../components/usemodal";
import { BottomIfor } from "../bottom/bottominfo";
import { ButtonforPh } from "../bottom/buttomforph";
import { CoursePageListContentPh } from "../courselistinfoph";
import { ShowBigImgPC } from "../../components/showbigimg";
import { Tips } from "../../components/tips";
import { Floatingpc } from "../../components/floatingpc";
import { Floatingph } from "../../components/floatingph";

function CoursePage_Perspective(props) {
  const { id } = useParams();
   const params = new URLSearchParams(props.location.search);
  let targetCode=params.get('targetCode')
  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      document.documentElement.style.overflow = "hidden";
    });
  }, []);
  return (
    <div>
      <CoursePagePerspectivebox {...props} name={id} targetCode={targetCode*1} />
    </div>
  );
}

function CoursePagePerspectivebox(props) {
  const [active, setActive] = useState(undefined);
  const [seriseShow, setSeriseShow] = useState(undefined);
  const [content, setContent] = useState([
    { courseType: null, targetCode: "", courseContent: "", showCourse: "" },
  ]);
  const [showcourse, setShowCourse] = useState([]);
  const [tabCourse,setTabCourse]=useState([])
  const [trangle, setTrangle] = useState(0);
  const [shows, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
const [showArrowLeft,setShowArrowLeft]=useState(false)
const [showArrowRight, setShowArrowRight] = useState(false);
const wrapperRef=useRef(null)
  const { show, hide, RenderModal } = useModal();
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  useEffect(() => {
    document.addEventListener("touchstart", hideFloating);
  }, []);

  const reload = useCallback(async () => {
    let index = props.name * 1;
    let [course, periods] = await Promise.all([
      GetCourseContent(),
      getCoursePeriods(index),
    ]);
    if (course.code !== 0 && periods !== 0) {
      message.error(course.message || periods.message);
      return;
    } else {
      let childArr = course.result.filter((i) => i.parentCourseId === index);
      let newTabArr = course.result
        .filter((i) => i.id === index)
        .concat(childArr);
      setActive(index); //当前的tab
      setTabCourse(newTabArr); //tab数组
      setSeriseShow(0); //第一个tab0,其他tab不等于0
      let content = course.result.filter((i) => i.id === index);

      setTrangle(
        props.targetCode ? props.targetCode : content[0].defaultSelect * 1
      ); //当前默认展示的课程期数

      setShowCourse(content[0].coursepriods.slice(0, 2)); //
      setContent(content);
    }
  }, [props.name, props.targetCode]);


 
useLayoutEffect(() => {
  if (wrapperRef.current) {
    const { scrollWidth, clientWidth, } = wrapperRef.current;
    setShowArrowRight(scrollWidth > clientWidth);
  }
}, [tabCourse]);

const onScroll=(e)=>{
  const el = e.target;

  if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 2) {
    setShowArrowRight(false)
    setShowArrowLeft(true)
  }
  if(el.scrollLeft<2){
    setShowArrowRight(true);
    setShowArrowLeft(false);
  }
}
// useEffect(()=>{
//   console.log(active)
// },[active])
  
  useEffect(() => {
    reload();
  }, [reload]);
  return (
    <div className="course-perspectve">
      <Row>
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          <Floatingpc
            show={shows}
            showWindow={showWindow}
            text={text}
            setText={setText}
          />
          <div className="videobox" style={{ position: "relative" }}>
            <div className="videomask">
              {/* <div className="videobtncenter"><div className="videobtn" style={show ? { display: "block" } : { display: "none" }}></div></div> */}
              {/* <video className="videoplaybox-play" width="100%" height="100%" src="/video/video2.mp4" controls poster="/images/images/course_video_cover_02.jpg"></video> */}
            </div>
            {show && (
              <RenderModal>
                <div className="videoplaybox">
                  <video
                    className="videoplaybox-play"
                    width="800"
                    height="500"
                    src="/video/video2.mp4"
                    controls
                  ></video>
                  <div className="closevideobtn" onClick={() => hide()}>
                    X
                  </div>
                </div>
              </RenderModal>
            )}
          </div>
          <div>
            <div className="coursePage-perspective-box">
              <div className="coursePage-perspective-nav">
                {tabCourse.map((i, index) => {
                  return (
                    <div
                      key={i.id}
                      className={`coursePage-perspective-title ${
                        active === i.id ? "bottom-active" : ""
                      } ${index > 0 ? "tabMargnClass" : ""}`}
                      onClick={() => {
                        setSeriseShow(index);
                        setActive(i.id);
                      }}
                    >
                      <div className="coursePage-perspective-cn-title">
                        <span>{i.nameCN}</span>
                      </div>
                      <div className="coursePage-perspective-en-title">
                        <span>{i.name}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={0} xl={0}>
          <Floatingph
            showmp={showmp}
            showFloating={showFloating}
            text={text}
            setText={setText}
          />
          <div className="video-box">
            <div className="cover-bg">
              {/* <div className={`${videobox ? '' : 'play-btn-layer-ph'}`}></div>
              {videobox ? <video className="videoplaybox-play2" width="100%" height="100%" src="/video/video2.mp4" ></video> : ''} */}
            </div>
          </div>
          <div className="course-nav-ph-wrapper">
            {showArrowLeft ? <div className="leftArrow"></div> : <div></div>}

            <div className="course-nav-ph" ref={wrapperRef} onScroll={onScroll}>
              {tabCourse.map((i, index) => {
                return (
                  <div className={"course-nav-box"} key={i.id}>
                    <div
                      className={`course-nav1 ${
                        active === i.id ? "bottom-active" : ""
                      }`}
                      onClick={() => {
                        setSeriseShow(index);
                        setActive(i.id);
                      }}
                    >
                      <div className="coursePage-perspective-cn-title-ph">
                        {i.nameCN}
                      </div>
                      <div className="coursePage-perspective-en-title-ph">
                        <span>{i.name}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {showArrowRight ? <div className="rightArrow"></div> : <div></div>}
          </div>
        </Col>
      </Row>
      <div style={{ minHeight: "600px" }}>
        {seriseShow === 0 ? (
          <CoursePagePerspectiveIntroduction
            trangle={trangle}
            setTrangle={setTrangle}
            name={props.name}
            {...props}
            showcourse={showcourse}
            content={content}
          />
        ) : (
          <CoursePagePerspectiveDLC
            seriseShow={seriseShow}
            name={props.name}
            content={content}
            active={active}
            {...props}
          />
        )}
      </div>
    </div>
  );
}

function CoursePagePerspectiveIntroduction(props) {
  let { showcourse = [], trangle, setTrangle, content } = props;
  // useEffect(() => {
  //   setTrangle(showcourse.findIndex(i => i.id === name * 1) === -1 ? 0 : showcourse.findIndex(i => i.id === name * 1))
  // }, [name, showcourse])
  let currentShowCourse = showcourse.find((i) => i.id === trangle) || {};
  const { show, hide, RenderModal } = useModal();
  const [url, setUrl] = useState();
  const [stuwork, setStuWork] = useState([]);
  const currentimg = useRef();
  const [totop, setTotop] = useState(false);
  const [savetips, setSaveTips] = useState({});
  const {
    show: showtips,
    hide: hidetips,
    RenderModal: RenderTips,
  } = useModal();
  function backtotop() {
    let oscroll = document.querySelector(".home-content");
    oscroll.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  useEffect(() => {
    let oscroll = document.querySelector(".home-content");
    function con(e) {
      if (e.target.scrollTop > 700) {
        setTotop(true);
      } else {
        setTotop(false);
      }
    }
    oscroll.addEventListener("scroll", con);

    return function cleanup() {
      oscroll.removeEventListener("scroll", con);
    };
  }, []);
  let settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    dots: true,
  };

  useEffect(() => {
    if (!content[0].student_works) return;
    else {
      setStuWork(content[0].student_works);
    }
  }, [content]);

  const prev = () => {
    currentimg && currentimg.current.prev();
  };
  const next = () => {
    currentimg && currentimg.current.next();
  };

  let sendstuwork = stuwork.reduce((prev, next) => {
    prev.push(next.url);
    return prev;
  }, []);
  const divnum = Math.ceil(stuwork.length / 20);
  let arr = new Array(divnum).fill("").map((_, index) => {
    return stuwork
      .sort((a, b) => b.sort - a.sort)
      .slice(index * 20, (index + 1) * 20);
  });
  // useEffect(() => {
  //   let domtxt = document.querySelector('.isExpandDiv')
  //   if (!(domtxt)) return
  //   let num = window.getComputedStyle(domtxt, null).height.replace('px', '') * 1

  //   if (num === 0 || isNaN(num)) {
  //     setIsExpand(0)
  //     return;
  //   }
  //   if (num <= 200) {
  //     setIsExpand(3)
  //   } else {
  //     setIsExpand(1)
  //   }
  //   return num = null
  // }, [trangle, showcourse])
  let titleJson = {
    courseDescription: {
      title: "1.课程介绍",
      description: "COURSE,INTRODUCTION",
      component: (props) => {
        return (
          <div style={{ height: props.HTMLDATA === "" ? "0px" : "auto" }}>
            <pre
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "1.5",
                overflow: "hidden",
                height: props.HTMLDATA === "" ? "0" : "auto",
              }}
            >
              <div
                className="braft-output-content"
                style={{ height: props.HTMLDATA ? "auto" : "0px" }}
                dangerouslySetInnerHTML={{ __html: props.HTMLDATA }}
              ></div>
            </pre>
          </div>
        );
      },
    },
    courseTable: {
      title: "2.课程表",
      description: "CLASS,SCHEDULE,CARD",
      component: (props) => {
        // style={{ height: isExpand === 2 ? 'auto' : isExpand === 0 ? '0' : isExpand === 1 ? '200px' : 'auto', overflow: 'hidden' }}
        return (
          <div>
            <pre
              className={"isExpandDiv"}
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "1.5",
                overflow: "hidden",
              }}
            >
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: props.HTMLDATA }}
              ></div>
            </pre>
          </div>
        );
      },
    },
    needDevice: {
      title: "3.需要的设备",
      description: "EQUIPMENT,NEEDED",
      component: (props) => {
        return (
          <div style={{ height: props.HTMLDATA === "" ? "0px" : "auto" }}>
            <pre
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "1.5",
                overflow: "hidden",
                height: props.HTMLDATA === "" ? "0" : "auto",
              }}
            >
              <div
                className="braft-output-content"
                style={{ height: props.HTMLDATA ? "auto" : "0px" }}
                dangerouslySetInnerHTML={{ __html: props.HTMLDATA }}
              ></div>
            </pre>
          </div>
        );
      },
    },
  };
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        {/* <CoursePageListContent trangle={trangle} {...props} showcourse={showcourse} name={name}/> */}
        <div className="coursePage-perspective-detail">
          <div
            style={totop ? { opacity: 1 } : { opacity: 0 }}
            className="backtotop"
            onClick={backtotop}
          ></div>
          <div className="course-perspective-introduction-box">
            <div className="course-perspective-introduction-detail1">
              {Object.keys(currentShowCourse).map((i, index) => {
                if (!titleJson[i]) return false;
                let Component = titleJson[i].component;
                let arrSpan = titleJson[i].description.split(",");
                return (
                  <div className="course-title" key={index}>
                    <div className="course-introduction-title-box">
                      <div>
                        <span>{titleJson[i].title}</span>
                      </div>
                      <div>
                        {arrSpan.map((j) => (
                          <span key={j}>{j}</span>
                        ))}
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      {Component ? (
                        <Component HTMLDATA={currentShowCourse[i]} />
                      ) : (
                        <pre
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            lineHeight: "30px",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            className="braft-output-content"
                            dangerouslySetInnerHTML={{
                              __html: currentShowCourse[i],
                            }}
                          ></div>
                        </pre>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="course-perspective-introduction-detail2">
              <div className="serise-box">
                <div className="serise-box-title">
                  {showcourse.map((i) => {
                    return (
                      <div
                        key={i.id}
                        className={i.id === trangle ? "trangle-active" : ""}
                        onClick={() => {
                          setTrangle(i.id);
                        }}
                      >
                        {i.coursePriodsName}
                      </div>
                    );
                  })}
                </div>
                <div className="serise-box-content">
                  {showcourse.map((i) => {
                    return (
                      <pre
                        key={i.id}
                        style={{
                          display: `${i.id === trangle ? "block" : "none"}`,
                          wordWrap: "break-word",
                          whiteSpace: "break-spaces",
                          overflow: "hidden",
                        }}
                        className="braft-output-content"
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: i.basic }}
                        ></div>
                      </pre>
                    );
                  })}
                </div>
                <div className="serise-box-footer">
                  {showcourse.map((i) => {
                    return (
                      <div
                        key={i.id}
                        style={{
                          display: `${i.id === trangle ? "block" : "none"}`,
                        }}
                      >
                        {i.type === 0 && i.target === "" ? (
                          <div className="buttontextstyle">{i.buttonText}</div>
                        ) : i.type === 1 &&
                          i.buttonText !== "" &&
                          i.modalContent !== "" ? (
                          <div
                            className="course-join-btn"
                            onClick={() => {
                              showtips();
                              setSaveTips(i.modalContent);
                            }}
                          >
                            <span>{i.buttonText}</span>
                          </div>
                        ) : i.target !== "" && i.buttonText !== "" ? (
                          <div className="course-join-btn">
                            <a href={i.target} rel="noreferrer" target="_blank">
                              {i.buttonText}
                            </a>
                          </div>
                        ) : i.buttonText !== "" ? (
                          <div className="buttontextstyle">{i.buttonText}</div>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  })}
                  {/* {modal ? <Tips hidetips={hidetips} savetips={savetips} setModal={setModal} /> : ''} */}
                  {showtips && (
                    <RenderTips>
                      <Tips hidetips={hidetips} savetips={savetips} />
                    </RenderTips>
                  )}
                  <NavLink
                    className="course-common-problem"
                    to="/commonproblem/seid/0"
                  >
                    <span>课程常见问题</span>
                    <span>》》</span>
                  </NavLink>
                </div>
              </div>
              <div className="notify">
                <div>
                  <div className="icon1"></div>
                  <div>
                    <span>
                      通过 直播云 授课平台进行直播授课，支持全平台设备
                    </span>
                  </div>
                </div>
                <div>
                  <div className="icon2"></div>
                  <div>
                    <span>直播课程结束后30分钟内即可观看课程回放</span>
                  </div>
                </div>
                <div>
                  <div className="icon3"></div>
                  <div>
                    <span>
                      科学合理的作业步骤安排，作业难度丝滑递进，可以直观看到自己的进步
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="studentsworkbox">
            {/* <StudentWorkBox currentShowCourse={currentShowCourse.studentWork}/> */}
            <div className="coursestudentshow">
              <div className="stuworktitle">
                <div>学生作品</div>
                <div>STUDENT WORKS</div>
              </div>
              <div className="stuworkslidebox">
                <div className="slideleftarrow" onClick={prev}></div>
                <div className="stuworkcontent">
                  <Carousel {...settings} ref={currentimg}>
                    {arr &&
                      arr.map((i, index) => {
                        return (
                          <div key={index} className="stuworkbox">
                            {i &&
                              i.map((j) => {
                                return (
                                  <div
                                    key={j.id}
                                    className="stuimgstyle"
                                    onClick={() => {
                                      show();
                                      setUrl(j.url);
                                    }}
                                  >
                                    <img src={j.smallPicture} alt="加载中" />
                                  </div>
                                );
                              })}
                          </div>
                        );
                      })}
                  </Carousel>
                </div>
                <div className="sliderightarrow" onClick={next}></div>
              </div>
              {show && (
                <RenderModal>
                  <ShowBigImgPC
                    data={sendstuwork && sendstuwork}
                    hide={hide}
                    url={url}
                  />
                </RenderModal>
              )}
            </div>
          </div>
        </div>
        <BottomIfor />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <CoursePageListContentPh
          setSaveTips={setSaveTips}
          showtips={showtips}
          showcourse={showcourse}
          content={content}
          trangle={trangle}
          setTrangle={setTrangle}
        />
        <ButtonforPh />
      </Col>
    </Row>
  );
}

// function ReplaceStr(str=''){
//         return str.replace(/<([a-z]+?)(?:\s+?[^>]*?)?>\s*?<\/\1>/ig,(value)=>{
//             let newstr = value.replace(/<([a-z]+?)(?:\s+?[^>]*?)?>\s*?<\/\1>/ig,'')
//             return newstr
//         })
// }

export default CoursePage_Perspective;
